import { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { ToastContainer } from 'react-toastify'; //toster
import 'react-toastify/dist/ReactToastify.css';

import Menubar from './components/page-components/navgiationBar';
import Footer from './components/page-components/footer';

import Home from './pages/home';
import MyCollection from './pages/myCollection';
import MyBids from './pages/myBids';
import ViewNFT from './pages/viewNFT';
import Adoption from './pages/adoption';
import Market from './pages/market';
import ViewAuction from './pages/viewAuction';
import MyProfile from './pages/myProfile';
import ExchangeToken from './pages/exchangeToken';
import Help from './pages/help';
import PageNotFound from './pages/pageNotFound';

import {BrowserRouter as Router, Switch, Route } from "react-router-dom";

function App() {

  return (
    <Router>
    <div className="App">
      <ToastContainer autoClose={4000} limit={3}></ToastContainer>
      <header className="App-header">
        <Menubar/>
      </header>
      <div className="pageData">
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            <Route path="/view-nft/:id">
              <ViewNFT />
            </Route>
            <Route exact path="/my-collection">
              <MyCollection />
            </Route>
            <Route exact path="/my-bids">
              <MyBids />
            </Route>
            <Route exact path="/adoption">
              <Adoption />
            </Route>
            <Route exact path="/market">
              <Market />
            </Route>
            <Route path="/view-auction/:id">
              <ViewAuction />
            </Route>
            <Route exact path="/my-profile">
              <MyProfile />
            </Route>
            <Route exact path="/exchange-token">
              <ExchangeToken/>
            </Route>
            <Route exact path="/help">
              <Help/>
            </Route>
            <Route path="*">
              <PageNotFound/>
            </Route>
          </Switch>
      </div>
      <div className="footer">
        <Footer/>
      </div>
    </div>
      </Router>
  );
}

export default App;
